<p-toast key="toast" [style]="{marginTop: '80px'}"></p-toast>
<div class="card bg-light" style="margin-top: 10px;">
    <div *ngIf="valuesCount == 5 || isNewCase === true" class="card-body">
        <table class="table table-responsive">
            <tr style="font-size: smaller">
                <th>&nbsp;</th>
                <th>Roll Value per Applicant</th>
                <th>Applicant Opinion of Value</th>
                <th>Roll Value per Assessor</th>
                <th>Appeals Board Valuation</th>
            </tr>
            <tr>
                <td class="prd-label"> Land </td>
                <td> <input class="form-control" [(ngModel)]='myValueApplicant.landValue' (blur)="addCommas(1)" (focus)="removeCommas(1)"> </td>
                <td> <input class="form-control" [(ngModel)]='myValueOpinion.landValue' (blur)="addCommas(2)" (focus)="removeCommas(2)"> </td>
                <td> <input class="form-control" [(ngModel)]='myValueAssessor.landValue' (blur)="addCommas(3)" (focus)="removeCommas(3)"> </td>
                <td> <input class="form-control" [(ngModel)]='myValueFinal.landValue' (blur)="addCommas(4)" (focus)="removeCommas(4)"> </td>
            </tr>
            <tr>
                    <td class="prd-label" > Improvements </td>
                    <td> <input class="form-control" [(ngModel)]='myValueApplicant.improveValue' (blur)="addCommas(11)" (focus)="removeCommas(11)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueOpinion.improveValue' (blur)="addCommas(12)" (focus)="removeCommas(12)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueAssessor.improveValue' (blur)="addCommas(13)" (focus)="removeCommas(13)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueFinal.improveValue' (blur)="addCommas(14)" (focus)="removeCommas(14)"> </td>
            </tr>
            <tr>
                    <td class="prd-label"> Fixtures </td>
                    <td> <input class="form-control" [(ngModel)]='myValueApplicant.fixturesValue' (blur)="addCommas(21)" (focus)="removeCommas(21)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueOpinion.fixturesValue' (blur)="addCommas(22)" (focus)="removeCommas(22)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueAssessor.fixturesValue' (blur)="addCommas(23)" (focus)="removeCommas(23)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueFinal.fixturesValue' (blur)="addCommas(24)" (focus)="removeCommas(24)"> </td>
            </tr>
            <tr>
                    <td class="prd-label"> Personal Property </td>
                    <td> <input class="form-control" [(ngModel)]='myValueApplicant.personalValue' (blur)="addCommas(31)" (focus)="removeCommas(31)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueOpinion.personalValue' (blur)="addCommas(32)" (focus)="removeCommas(32)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueAssessor.personalValue' (blur)="addCommas(33)" (focus)="removeCommas(33)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueFinal.personalValue' (blur)="addCommas(34)" (focus)="removeCommas(34)"> </td>
            </tr>
            <tr>
                    <td class="prd-label"> Mineral Rights </td>
                    <td> <input class="form-control" [(ngModel)]='myValueApplicant.mineralValue' (blur)="addCommas(41)" (focus)="removeCommas(41)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueOpinion.mineralValue' (blur)="addCommas(42)" (focus)="removeCommas(42)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueAssessor.mineralValue' (blur)="addCommas(43)" (focus)="removeCommas(43)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueFinal.mineralValue' (blur)="addCommas(44)" (focus)="removeCommas(44)"> </td>
            </tr>
            <tr>
                    <td class="prd-label"> Trees and Vines </td>
                    <td> <input class="form-control" [(ngModel)]='myValueApplicant.treesValue' (blur)="addCommas(51)" (focus)="removeCommas(51)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueOpinion.treesValue' (blur)="addCommas(52)" (focus)="removeCommas(52)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueAssessor.treesValue' (blur)="addCommas(53)" (focus)="removeCommas(53)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueFinal.treesValue' (blur)="addCommas(54)" (focus)="removeCommas(54)"> </td>
            </tr>
            <tr>
                    <td class="prd-label"> Total Value </td>
                    <td>{{myValueApplicant.totalValue | number}}</td>
                    <td>{{myValueOpinion.totalValue | number}}  </td>
                    <td>{{myValueAssessor.totalValue | number}}  </td>
                    <td>{{myValueFinal.totalValue | number}}  </td>
            </tr>
            <tr>
                    <td class="prd-label"> Exemptions </td>
                    <td> <input class="form-control" [(ngModel)]='myValueApplicant.exemptValue' (blur)="addCommas(61)" (focus)="removeCommas(61)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueOpinion.exemptValue' (blur)="addCommas(62)" (focus)="removeCommas(62)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueAssessor.exemptValue' (blur)="addCommas(63)" (focus)="removeCommas(63)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueFinal.exemptValue' (blur)="addCommas(64)" (focus)="removeCommas(64)"> </td>
            </tr>
            <tr>
                    <td class="prd-label"> Penalties </td>
                    <td> <input class="form-control" [(ngModel)]='myValueApplicant.penaltyValue' (blur)="addCommas(71)" (focus)="removeCommas(71)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueOpinion.penaltyValue' (blur)="addCommas(72)" (focus)="removeCommas(72)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueAssessor.penaltyValue' (blur)="addCommas(73)" (focus)="removeCommas(73)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueFinal.penaltyValue' (blur)="addCommas(74)" (focus)="removeCommas(74)"> </td>
            </tr>
            <tr>
                    <td class="prd-label"> Net Total </td>
                    <td> <input class="form-control" [(ngModel)]='myValueApplicant.netValue' (blur)="addCommas(81)" (focus)="removeCommas(81)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueOpinion.netValue' (blur)="addCommas(82)" (focus)="removeCommas(82)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueAssessor.netValue' (blur)="addCommas(83)" (focus)="removeCommas(83)"> </td>
                    <td> <input class="form-control" [(ngModel)]='myValueFinal.netValue' (blur)="addCommas(84)" (focus)="removeCommas(84)"> </td>

                </tr>
        </table>
        <div class="form-row">
            <label for="cmbRollYear" class="col-sm-1 offset-1 col-form-label prd-label">Roll Year</label>
            <select id="cmbRollYear" class="form-control col-sm-2" [(ngModel)]='rollYear' (blur)="valueChanged(100)">
                <option></option>
                <option *ngFor="let rollYr of rollYearList" value="{{rollYr.desc}}">{{rollYr.desc}}</option>
            </select>
            <label for="cmbRollType" class="col-sm-1 offset-1 col-form-label prd-label">Roll Type</label>
            <select id="cmbRollType" class="form-control col-sm-2" [(ngModel)]='myValueCase.assessType' (blur)="valueChanged(101)">
                <option></option>
                <option *ngFor="let aType of assessTypes" value="{{aType}}">{{aType}}</option>
            </select>
            <!--
            <select id="cmbRollType" class="form-control col-sm-2" [(ngModel)]='myValueCase.assessType' (blur)="valueChanged(101)">
                <option></option>
                <option>Regular</option>
                <option>Supplemental</option>
            </select>
            -->

        </div>
        <hr />
        <div class="form-row" [hidden]="!allowAssessorValues">
            <button class="btn btn-sm btn-info col-sm-2 offset-4" title="Click to get Assessor values" [disabled]="disableGetSecure()" (click)="getSecureValues()"> Get Values Secured </button>
            <button [hidden]="true" class="btn btn-sm btn-secondary col-sm-2 offset-1" title="Click to get Assessor values for Unsecured property" [disabled]="disableGetUnsecure()" (click)="getUnsecureValues()"> Get Values Unsecured </button>
        </div>
    </div>
</div>

